// Content Section
import React from 'react'
import Helmet from "react-helmet"
import Header from './Header'
import TextBlock from './textblock.js'
import SubHeader from './SubHeader'
import '../styles/global.css'
import '../styles/block2.css'

export default function ContentSection(props) {
    
    return(
        
        <div class={props.divClass}>
        
            <div class='row'>
        
                <Header divClass="col-12 headerPadding" id={props.headerId} styles={props.headerStyles} title={props.heading}/>
                
                <TextBlock elementClass="standardText introPadding" text={props.text}/>
        
                {props.data.map((content_group) => 
                                
                    <div class={props.elementClass}>
                        
                        <SubHeader styles={props.subHeaderStyles} title={content_group.section_name}/> 
                             
                        <div class={props.dangerousClass} dangerouslySetInnerHTML={{ __html: content_group.text }} />
    
                    </div>
                )}
        
            </div>
             
            
        </div>
    
    );
}